import React from "react";
import Stack from "@mui/material/Stack";

export const PostPurchaseAudienceOverlapMessage = (
  <Stack spacing={1}>
    <div>
      <strong>Audience overlap detected.</strong> Only one post-purchase upsell
      can be shown per order.
    </div>
    <div>
      This upsell targets the same audience as an upsell that's already live, so
      it can't be started right now.
    </div>
    <div>
      In the meantime, add this offer as an additional rule on your live upsell.
    </div>
    <div>
      We're building multi-upsell support — this limit will be removed soon.
    </div>
  </Stack>
);
